The start date of the position.

This may only contain the year and month, e.g. `2019-01`.
